import * as Yup from 'yup'


/** Dropoff Inbound Receiving schema for Non-Exclusive Seller (have maximum quantity) */
const sellerInboundReceiveDropoffSchema = Yup.object().shape({
  received_quantity: Yup.number()
    .positive('Must be more than 0')
    .max(50, 'Inbound quantity cannot be more than 50')
    .required('Required'),
  weight: Yup.number().positive('Must be more than 0').required('Required')
})

export default sellerInboundReceiveDropoffSchema
